import { GetCustomersParams } from 'src/dto/CustomerNew';
import { CustomerPreview } from 'src/frontend-common/dto/Interfaces/ICustomerPreview';
import { baseApiWithCompanyId } from 'src/redux/services/baseApi';

export const customersApi = baseApiWithCompanyId.injectEndpoints({
  endpoints: (builder) => ({
    getCustomers: builder.query<{ items: CustomerPreview[]; total: number }, GetCustomersParams>({
      query: (params) => ({
        url: 'v1/customers',
        params: {
          ...params,
          search: params.search || '',
        },
      }),
      providesTags: [`Customers`],
    }),
  }),
});

export const { useGetCustomersQuery } = customersApi;
